import { render } from "./ACLSTraining.vue?vue&type=template&id=31f80730&scoped=true"
import script from "./ACLSTraining.vue?vue&type=script&lang=js"
export * from "./ACLSTraining.vue?vue&type=script&lang=js"

import "./ACLSTraining.vue?vue&type=style&index=0&id=31f80730&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f80730"]])

export default __exports__